var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',{attrs:{"placeholder":_vm.placeholder,"value":_vm.inputVal,"type":_vm.inputType,"allowClear":""},on:{"input":_vm.backValue}})}
var staticRenderFns = []

export { render, staticRenderFns }